import { render } from "./CompanyStep2WeflixPanel.vue?vue&type=template&id=71c2d84c&scoped=true"
import script from "./CompanyStep2WeflixPanel.vue?vue&type=script&lang=js"
export * from "./CompanyStep2WeflixPanel.vue?vue&type=script&lang=js"

import "./CompanyStep2WeflixPanel.vue?vue&type=style&index=0&id=71c2d84c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c2d84c"]])

export default __exports__